import apiClient from '@/services/http';
import axios from 'axios';
import router from '@/router';

export default {
    async login(credentials) {
        // Use a clean axios call to get the cookie
        // This ensures the XSRF-TOKEN is set in the browser
        const baseUrl = apiClient.defaults.baseURL.replace(/\/api\/?$/, '');
        // Add cache busting to avoid getting a cached CSRF token from LiteSpeed/Hostinger
        await axios.get(`${baseUrl}/sanctum/csrf-cookie?t=${Date.now()}`, { withCredentials: true });

        return apiClient.post('/auth/login', credentials);
    },
    // register(userData) {
    //     return apiClient.post('/auth/register', userData);
    // },
    async logoutAndClear(store) {
        try {
            await apiClient.post('/auth/logout');
        } catch (e) {
            console.error(e.message);
        } finally {
            localStorage.removeItem("authToken");
            localStorage.removeItem("refreshToken");
            store.state.user = undefined;
            store.state.isAuthenticated = false;
            router.push('/signin');
        }
    },
    async handleLoginAndStore(payload, store) {
        try {
            const response = await this.login(payload);
            const data = response.data?.data;

            // Store tokens for Bearer authentication fallback 
            // (fixes issues where cookies are blocked by Tracking Prevention)
            if (data?.access_token) {
                localStorage.setItem('authToken', data.access_token);
            }
            if (data?.refresh_token) {
                localStorage.setItem('refreshToken', data.refresh_token);
            }

            return data;
        } catch (e) {
            return Promise.reject(e);
        }
    },
    async runAuth(store, router, userApi) {
        try {
            const response = await userApi.getUserProfile();
            if (!response || !response.data || !response.data.data) {
                throw new Error('Invalid response format');
            }
            if (response.status !== 200) {
                throw new Error(`Auth failed with status ${response.status}`);
            }

            store.commit('userData', response.data.data);
            store.commit('setApiMode', response.data.data.api_mode || 'default');
            store.commit('authenticateUser');
            store.commit('setAppInitialLoaded', true);

            // Validate IndexedDB cache against server fingerprints on reload/login
            // Awaited to prevent race conditions with component mounting
            try {
                const { checkAndValidateFingerprints } = await import('@/utils/cacheService.js');
                await checkAndValidateFingerprints();
            } catch (e) {
                console.warn('[Auth] Failed to run IndexedDB fingerprint validation on reload:', e);
            }

            return response.data;
        } catch (error) {
            // If getUserProfile fails, clear tokens and state, redirect to login
            await this.logoutAndClear(store);
            return Promise.reject(error);
        }
    },
    async refreshToken(store) {
        try {
            const refreshToken = localStorage.getItem('refreshToken');
            if (!refreshToken) {
                throw new Error('No refresh token available');
            }
            const response = await apiClient.post('/auth/refresh', { refresh_token: refreshToken });
            // ✅ Check if response status is not 200
            if (response.status !== 200) {
                throw new Error(`Unexpected response status: ${response.status}`);
            }
            const { data } = response.data;
            localStorage.setItem('authToken', data.access_token);
            return response;
        } catch (error) {
            console.error(error.message);
            await this.logoutAndClear(store);
            throw error;
        }
    }
};
